<!--抄表管理信息列表电表 meterManager-->
<template>
  <div class="mymetermanager">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>设备名：</span>
              <el-input v-model="findDeviceName" placeholder="请输入设备名" style="width:140px"></el-input>
            </div>
            <div class="input-small mr-20">
              <span>编码：</span>
              <el-input v-model="deviceNo" placeholder="请输入设备编号" style="width:140px"></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主姓名：</span>
              <el-input v-model="ownerName" placeholder="请输入业主姓名" style="width:140px"></el-input>
            </div>
            <div class="input-small mr-20 myinput-mill">
              <span>抄表日期：</span>
              <el-select v-model="deductionFeeDay" clearable placeholder="请选择" style="width: 90px;">
                <el-option v-for="item in dateDay" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small mr-20 myinput-mill">
              <span>开户状态：</span>
              <el-select v-model="state" placeholder="请选择" style="width: 90px;">
                <el-option v-for="item in relevanceStatusList" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput-mill">
              <span>联网状态：</span>
              <el-select v-model="deviceState" placeholder="请选择" style="width: 90px;">
                <el-option v-for="item in connectStatusList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" plain @click="getDataList" class="search-btn">查询</el-button>
            <el-button type="primary" @click="addMeterSet" class="search-btn">新增</el-button>
            <el-button type="primary" @click="exportReport" class="search-btn">导出</el-button>
          </div>
        </el-scrollbar>
      </div>

      <div class="mytable" :style="{'height':heights+'px'}">
        <el-table :data="dataList" :height="heights - 20" border style="width: 100%;" v-loading="loading" stripe
          @selection-change="handleSelectionChange">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column type="index" width="90" label="序号" fixed align="center">
          </el-table-column>
          <el-table-column prop="deviceNo" label="设备编号" width="80">
          </el-table-column>
          <el-table-column prop="deviceName" label="设备名称" min-width="170">
          </el-table-column>
          <el-table-column label="设备别名(双击修改)" min-width="170">
            <template slot-scope="scope">
              <span @dblclick="bieming(scope.row)" v-show="!scope.row.inputed"
                style="min-width: 100px;display: block;height: 30px;">{{scope.row.deviceAlias}}</span>
              <el-input v-if="scope.row.inputed" v-model="scope.row.deviceAlias" placeholder="请输入设备名"
                @blur="bieming2(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名" width="100">
          </el-table-column>
          <el-table-column label="抄表时间" width="180">
            <template slot-scope="scope">
              <span>{{scope.row.meterReadingStartTime}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="realElectricQuantity" label="实时用电量(kWh)" width="130">
              <template slot-scope="scope">
                <span>{{realElectricQuantity(scope.row.realElectricQuantity)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="realAmount" label="实时电费(元)" width="120">
              <template slot-scope="scope">
                <span>{{realAmount(scope.row.realAmount)}}</span>
              </template>
            </el-table-column> -->
          <!-- <el-table-column prop="electricQuantity" label="近一小时电量(kWh)" width="150">
              <template slot-scope="scope">
                <span>{{electricQuantity(scope.row.electricQuantity)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="近一小时电费(元)" width="130">
              <template slot-scope="scope">
                <span>{{amount(scope.row.amount)}}</span>
              </template>
            </el-table-column> -->
          <el-table-column prop="accountType" label="付费方式" width="100">
            <template slot-scope="scope">
              <span v-show="scope.row.accountType == '0'">后付费</span>
              <span v-show="scope.row.accountType == '1'">预付费</span>
              <span v-show="scope.row.accountType == '2'">预付费-月账单</span>
              <span v-show="scope.row.accountType == undefined || scope.row.accountType == ''">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="是否开户" width="100" align="center">
            <template slot-scope="scope">
              <span class="wrongStatus" v-show="scope.row.state == 0">未开户</span>
              <span class="wrongStatus" v-show="scope.row.state == -1">欠费中</span>
              <span class="normalStatus" v-show="scope.row.state == undefined || scope.row.state == null">-</span>
              <span class="normalStatus" v-show="scope.row.state == 1">已开户</span>
            </template>
          </el-table-column>

          <el-table-column prop="deviceState" label="联网状态" width="100" align="center">
            <template slot-scope="scope">
              <span class="normalStatus" v-show="scope.row.deviceState == 1">在线</span>
              <span class="wrongStatus" v-show="scope.row.deviceState != 1">离线</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="state232" label="开合闸状态" width="100">
              <template slot-scope="scope">
                <img :src="getDeviceStateSource(scope.row.state232)" alt="" />
              </template>
            </el-table-column> -->
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="viewDetails(scope.row)" plain>详情</el-button>
              <!-- <el-button size="mini" type="primary" v-if="getDeviceStateSource2(scope.row.state232)"
                  @click="onOffState(scope.row,0)" plain>开</el-button>
                <el-button size="mini" type="danger" v-else @click="onOffState(scope.row,1)" plain>关</el-button> -->
              <el-button size="mini" type="danger" @click="deleteMeter(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="divider-line"></div>
      <!--分页-->
      <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
        @handleSizeChange="handleSizeChange" />
    </div>
    <VerifyPasswordDialog ref="verifyPasswordDialog"></VerifyPasswordDialog>
    <AddNewMeterDialog ref="addNewMeterDialog" @successList="getDataList"></AddNewMeterDialog>
  </div>
</template>

<script>
  import infoListMultipleSelection from './infoListMultipleSelection.vue'
  import VerifyPasswordDialog from './dialogs/VerifyPasswordDialog.vue'
  import AddNewMeterDialog from './dialogs/AddNewMeterDialog.vue'
  import meterManagerStore from './meterManagerStore.js'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import request from "@/api/http.js";
  export default {
    components: {
      infoListMultipleSelection,
      VerifyPasswordDialog,
      AddNewMeterDialog,
      elPagination
    },
    props: {},
    data () {
      return {

        heights: document.getElementById('app').clientHeight-240,
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        dataList: [],
        deviceNo: '',
        findDeviceName: '',
        ownerName: '',
        state: undefined,
        state232: undefined,
        userBalanceSum: undefined,
        deviceState: undefined,
        searchChange: false,
        deductionFeeDay: ' ',
        activeName: "first",
        meterType: "electric",
        loading: false,//页面加载
      }
    },
    created () {},
    mounted () {
      this.getDataList()
      meterManagerStore.commit('getAllMeterBillingMode',{
        unitId: this.nowUnit.id,
        activeName: this.activeName
      })
    },
    destroyed () {},
    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getMeterTimeInterval
      },
      columns () {
        return meterManagerStore.state.columns
      },
      userName () {
        return userName => {
          return userName==null||userName==''||userName==undefined? '-':userName
        }
      },
      electricQuantity () {
        return electricQuantity => {
          return electricQuantity==null||electricQuantity==''||electricQuantity==undefined? '-':electricQuantity
        }
      },
      deviceName () {
        return deviceName => {
          return deviceName
        }
      },
      amount () {
        return amount => {
          return amount==null||amount==''||amount==undefined? '-':(amount/100).toFixed(1)
        }
      },
      //实时电费
      realAmount () {
        return realAmount => {
          return realAmount==null||realAmount==''||realAmount==undefined? '-':(realAmount/100).toFixed(1)
        }
      },
      realElectricQuantity () {
        return realElectricQuantity => {
          return realElectricQuantity==null||realElectricQuantity==''||realElectricQuantity==undefined? '-':realElectricQuantity
        }
      },
      chargingStatusList () {
        return meterManagerStore.state.chargingStatusList
      },
      dateDay () {
        let list=[]
        for(let i=1;i<32;i++) {
          let obj={
            'label': i+'号',
            'value': i
          }
          list.push(obj)
        }
        return list
      },
      deviceStatusList () {
        return [{
          'label': '请选择',
          'value': ''
        },{
          'label': '开闸',
          'value': 0
        },{
          'label': '合闸',
          'value': 1
        }]
      },
      relevanceStatusList () {
        return [{
          label: '未开户',
          value: 0
        },{
          label: '已开户',
          value: 1
        },{
          label: '欠费中',
          value: -1
        }]
      },
      connectStatusList () {
        return [{
          label: '离线',
          value: 0
        },{
          label: '在线',
          value: 1
        }]
      },
      timeText () {
        return time => {
          if(time==null||time==undefined||time=='') {
            return '-'
          }
          return new Date(time).formatByDate()
        }
      },
      getDeviceStateSource () {
        return state => {
          if(parseInt(state)==1) {
            return this.$store.resourcesStore.getters.getResourcesByName('keli/state_on.png')
          } else if(parseInt(state)==0) {
            return this.$store.resourcesStore.getters.getResourcesByName('keli/state_off.png')
          }
          return this.$store.resourcesStore.getters.getResourcesByName('keli/state_no.png')
        }
      },
      getDeviceStateSource2 () {
        return state => {
          if(parseInt(state)==1) {
            return true
          } else if(parseInt(state)==0) {
            return false
          }
          return true
        }
      },
      timeList () {
        var list=[]
        list.push({
          text: '全部',
          value: ''
        })
        for(let i=1;i<32;i++) {
          list.push({
            text: i+'号',
            value: i
          })
        }
        return list
      }
    },
    watch: {
      nowUser (nv,ov) {
        meterManagerStore.commit('setNowUser',nv)
      },
      nowUnit (nv,ov) {
        meterManagerStore.commit('setNowUnit',nv)
        this.getDataList(nv)
        meterManagerStore.commit('getAllMeterBillingMode',this.nowUnit.id)
      },
      deviceNo (nv,ov) {
        this.searchChange=true
      },
      ownerName (nv,ov) {
        this.searchChange=true
      },
      state (nv,ov) {
        this.searchChange=true
      },
      deviceState (nv,ov) {
        this.searchChange=true
      },
      state232 (nv,ov) {
        this.searchChange=true
      },
      nowTimeInterval (nv,ov) {
        this.searchChange=true
      },
      pageIndex (nv,ov) {
        this.getDataList()
      },
      userBalanceSum (nv,ov) {
        this.userBalanceSum=0
      }
    },
    methods: {
      handleSelectionChange (v) {
        console.log(v,1);
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.getDataList();
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.getDataList();
      },
      compare (name) {
        return function(a,b) {
          //debugger
          var s1=a[name];
          var s2=b[name];
          return s1.localeCompare(s2);
        }
      },
      // 操作电表开关
      onOffState (item,state) {
        if(item.deviceState!=1) {
          return
        }
        // var state=parseInt(item.state232)==1? 1:0
        this.$refs.verifyPasswordDialog.open('密码验证',password => {
          this.$api.meterReadingApi.controlMeter(item.userId,item.deviceNo,state,password,respon => {
            this.$set(item,'state232',state)
            this.$dialogMethod.showMessage('操作成功')
          },err => {
            this.$dialogMethod.showMessage(err)
          })
        })
      },
      // 详情
      viewDetails (item) {
        //console.info("ppppppp"+JSON.stringify(item))
        meterManagerStore.commit('setDeviceInfo',item)
        this.$emit('viewDetails',item)
      },
      // 修改别名
      bieming2 (item) {
        var params={
          deviceNo: item.deviceNo,
          alias: item.deviceAlias,
        };
        item.inputed=false;
        request({url: "meterReading/settingDeviceAlias",method: "put",params}).then(res => {
          console.log(res,111);
        })
      },
      // 显示别名输入框
      bieming (item) {
        item.inputed=true;
      },
      // 删除电表
      deleteMeter (item) {
        //判断业主先解绑、
        this.$dialogMethod.openAgreeDialog("提示","确认删除设备名称："+item.deviceName+' 设备编号：'+item.deviceNo+' 的电表配置？',confirm => {
          this.$api.meterReadingApi.removeMeterReadingConfig(item.deviceNo,respon => {
            this.$dialogMethod.showMessage(respon)
            meterManagerStore.commit('getMeterReadingConfigList',this.nowUnit.id)
            this.getDataList()
          },err => {
            this.$dialogMethod.showMessage(err)
          })
        },cancel => {
          return
        },true)
      },
      // 获取抄表列表信息
      getDataList () {
        console.log("查询");
        if(isempty(this.nowUnit)) {
          return
        }
        if(this.searchChange) {
          this.pageIndex=1
          this.searchChange=false
        }

        //对参数给值
        this.loading=true
        this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(this.nowUnit.id,this.pageIndex,this.pageSize,this.deviceNo,this.findDeviceName,this.ownerName,this.state,this.state232,this.deviceState,this.deductionFeeDay,this.meterType,respon => {
          this.loading=false
          var d=copy(respon.dataList.sort(this.compare('deviceName')));
          d.map(v => {
            if(v.meterReadingStartTime) {
              v.meterReadingStartTime=this.parseTime(v.meterReadingStartTime,'{y}-{m}-{d} {h}:{i}:{s}')
            }
            v.inputed=false;
          })
          this.dataList=d;
          this.total=respon.total
        })
      },
      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 添加电表配置
      addMeterSet () {
        this.$refs.addNewMeterDialog.dialogFormVisible=true
      },
      // 导出报表
      exportReport () {
        if(isempty(this.deductionFeeDay)) {
          this.$dialogMethod.showMessage('请选择抄表日期！')
          return
        }
        var title=this.nowUnit.name+'电表信息'
        this.$store.cacheStore.state.load=true;
        this.$api.meterReadingApi.exportUnitMeterReadingConfig(this.nowUnit.id,this.deviceNo,this.ownerName,this.state,this.deductionFeeDay,'','electric',respon => {
          this.$store.cacheStore.state.load=false
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        })
      },
      // 切换每页显示条数
      pageSizeChange (pageSize) {
        this.pageIndex=1
        this.pageSize=pageSize
        this.getDataList()
      },
      // 切换页码
      jumpToPage (pageIndex) {
        this.pageIndex=pageIndex
        this.getDataList()
      },
    }
  }
</script>

<style scoped lang="scss">
  .mymetermanager {
    width: 100%;
    height: 100%;

    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      background-color: #fff;
      box-sizing: border-box;
    }

    .myinput-mill {
      /deep/.el-input__inner {
        width: 90px;
      }

      /deep/.el-input {
        width: 90px !important;
      }
    }
  }

  .searchContainer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 0px;
  }

  .searchContainer>div {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
  }

  .searchContainer label {
    margin-right: 6px;
  }

  .searchContainer input {
    border-color: #DCDFE6;
    min-width: 130px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 10px;
  }

  .searchContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .searchContainer>>>.selection>p {
    line-height: 34px;
    height: 34px;
    padding: 0;
  }

  .selectDateTime {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 176px;
    height: 34px;
    padding: 0 6px;
    background: #FFFFFF;
    border-radius: 6px;
    border: solid 1px #DCDFE6;
    margin-right: 20px;
  }

  .selectDateTime>span {
    width: 140px;
    line-height: 34px;
    height: 100%;
    cursor: pointer;
  }

  .selectDateTime>img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .searchContainer>button {
    height: 36px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .infoListContainer {
    /* padding: 0 20px 250px 20px; */
    height: calc(100% - 115px);
  }

  .infoListContainer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .infoListContainer::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .infoListContainer::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .noDrop {
    cursor: no-drop !important;
  }

  .marginRightNone {
    margin-right: 0;
  }

  @media screen and (max-width: 1600px) {
    .searchContainer label {
      display: block;
      margin-right: 0;
    }

    .infoListContainer {
      height: calc(100% - 96px);
    }
  }
</style>